'use client';

import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';

import { cn } from '@ui/lib/utils';

function Avatar({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Root>) {
  return (
    <AvatarPrimitive.Root data-slot="avatar" className={cn('relative flex size-8 shrink-0 overflow-hidden rounded-full', className)} {...props} />
  );
}

function AvatarImage({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Image>) {
  return <AvatarPrimitive.Image data-slot="avatar-image" className={cn('aspect-square size-full', className)} {...props} />;
}

function AvatarFallback({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Fallback>) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn('bg-secondary flex size-full items-center justify-center rounded-full', className)}
      {...props}
    />
  );
}

function UserAvatar({
  user,
  avatarClassName,
  imageClassName,
  fallbackClassName,
}: {
  user: { fullName: string; avatar?: string };
  avatarClassName?: string;
  imageClassName?: string;
  fallbackClassName?: string;
}) {
  const avatarFallbackName = `${user.fullName.charAt(0).toUpperCase()}${user.fullName.split(' ')[1] ? user.fullName.split(' ')[1]?.charAt(0).toUpperCase() : ''}`;
  return (
    <Avatar className={cn('rounded-lg', avatarClassName)}>
      <AvatarImage src={user.avatar} alt={user.fullName} className={imageClassName} />
      <AvatarFallback className={cn('rounded-lg', fallbackClassName)}>{avatarFallbackName}</AvatarFallback>
    </Avatar>
  );
}

export { Avatar, AvatarImage, AvatarFallback, UserAvatar };
